import AdminShow from "../components/admin/index.vue";
import AdminProjects from "../components/admin/projects/index.vue";

export default [
  {
    name: "AdminShow",
    path: "/admin",
    component: AdminShow,
    meta: { requiresAuth: true, requiresAdmin: true },
    redirect: { name: "AdminProjects" },
    children: [
      {
        path: "projects",
        name: "AdminProjects",
        component: AdminProjects,
      },
      {
        path: "*",
        name: "Admin404",
        redirect: { name: "AdminProjects" },
      },
    ],
  },
];
